import { render, staticRenderFns } from "./ImportationComponent.vue?vue&type=template&id=be1f8908&scoped=true"
import script from "./ImportationComponent.vue?vue&type=script&lang=js"
export * from "./ImportationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1f8908",
  null
  
)

export default component.exports